import { useDispatch, useSelector } from "react-redux";
import { addFind, addType } from "../features/filter/filterSlice";
import { useState } from "react";
import { updateCurrentPage } from "../features/pagination/paginationSlice";

export const Filter = () => {
    const dispatch = useDispatch();

    const { type, find } = useSelector((state) => state.filter) || {};
    const [search, setSearch] = useState(find);

    // type filter
    const typeHandler = (e) => {
        dispatch(addType(e.target.value));
        dispatch(updateCurrentPage(1));
    };
    // search handler
    const searchHandler = (e) => {
        e.preventDefault();
        dispatch(addFind(search));
        dispatch(updateCurrentPage(1));
    };

    const clearAllFiler = () => {
        setSearch("");
        dispatch(addType(""));
        dispatch(addFind(""));
    };

    return (
        <>
            <div className="border rounded p-4">
                <form onSubmit={searchHandler}>
                    <div className="mb-3">
                        <input
                            type="text"
                            placeholder="Find..."
                            className="h-10 px-3 border rounded texts-m w-full focus:outline-none"
                            required
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </form>
                <div className="flex items-center gap-4">
                    <label className="flex items-center gap-1 text-sm">
                        <input
                            type="radio"
                            name="type"
                            value="income"
                            onChange={typeHandler}
                            checked={type === "income"}
                        />
                        <span>Income</span>
                    </label>
                    <label className="flex items-center gap-1 text-sm">
                        <input
                            type="radio"
                            name="type"
                            value="expense"
                            onChange={typeHandler}
                            checked={type === "expense"}
                        />
                        <span>Expense</span>
                    </label>
                    {type || find ? (
                        <button
                            onClick={clearAllFiler}
                            className="h-6 px-4 bg-green-200 text-green-600 rounded-full hover:bg-green-300 duration-200 text-sm"
                        >
                            Clear Filter
                        </button>
                    ) : null}
                </div>
            </div>
        </>
    );
};
